﻿import React, {
    useContext,
    useRef,
    useState,
    useEffect,
    useLayoutEffect,
    Fragment,
} from "react";

import { WaitingListFlowContext } from "../WaitingListFlowContext";
import { validateFormObject } from "../Validation";
import { account } from "../Endpoints";

import { Heading } from "../partials/Heading";
import { BackNavigation } from "../partials/BackNavigation";
import CreateAccountPrivate from "./CreateAccountPrivate";
import CreateAccountBusiness from "./CreateAccountBusiness";
import CreateAccountGuest from "./CreateAccountGuest";

import { Divider } from "../../../../../Resources/Scripts/_Shared/elements/Divider";
import { TwoColumnWrapper } from "../../../../../Resources/Scripts/_Shared/elements/ColumnWrapper";
import { DropdownlistWithLabel } from "../../../../../Resources/Scripts/_Shared/elements/DropdownlistWithLabel";
import { CheckboxWithLabel } from "../../../../../Resources/Scripts/_Shared/elements/CheckboxWithLabel";
import { Error } from "../../../../../Resources/Scripts/_Shared/elements/Error";
import { shouldAccountBeUpdated } from "../../../../../Resources/Scripts/_Shared/helpers";

const CreateAccount = (props) => {
    const { waitingListFlowContext, setWaitingListFlowContext } =
        props.editSettings || props.formLogin
            ? {
                  waitingListFlowContext: props.waitingListFlowContext,
                  setWaitingListFlowContext: null,
              }
            : useContext(WaitingListFlowContext);
    const formLang = {
        ...waitingListFlowContext.episerver,
        ...waitingListFlowContext.localization.global,
        ...waitingListFlowContext.localization.createAccount,
    };

    const isGuestAccount = waitingListFlowContext.guest;

    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);
    const [enableSave, setEnableSave] = useState(!props.editSettings);
    const [showSaveButtonCheck, setShowSaveButtonCheck] = useState(false);
    const topOfContainerRef = useRef(null);
    const currentLanguage = document.querySelector("html").getAttribute("lang");
    const disableOthers =
        (waitingListFlowContext.country !== "no" &&
            formLang.invoicePreference === "EDI") ||
        formLang.invoicePreference === "E_INVOICE" ||
        formLang.invoicePreference === "FINVOICE";
    const render = useRef(1);

    // få in detta från BE och sätt val; guest är alltid B2C, men kan vara te.x. landlord
    const accountSelectionOptions = [
        { Text: formLang.accountTypeOptions.private, Id: 1, Value: "B2C" },
        { Text: formLang.accountTypeOptions.business, Id: 2, Value: "B2B" },
    ];

    var countrySelectionOptions = [];
    for (var c in formLang.countryOptions) {
        countrySelectionOptions.push({ Text: c, Id: c });
    }

    const languageOptions = [
        ...(waitingListFlowContext.country === "fi"
            ? [{ id: "fi", text: formLang.languageOptions.fi }]
            : []),
        ...(waitingListFlowContext.country === "fi" ||
        waitingListFlowContext.country === "se"
            ? [{ id: "sv", text: formLang.languageOptions.se }]
            : []),
        ...(waitingListFlowContext.country === "no"
            ? [{ id: "no", text: formLang.languageOptions.no }]
            : []),
        ...[{ id: "en", text: formLang.languageOptions.en }],
    ];

    const invoiceOptions =
        waitingListFlowContext.country === "se" &&
        waitingListFlowContext.episerver.paymentMethod &&
        waitingListFlowContext.episerver.paymentMethod === "DIRECT_DEBIT"
            ? [
                  {
                      id: "EMAIL",
                      text: formLang.invoiceOptions.emailreceipt,
                      disabled: false,
                  },
                  {
                      id: "PAPER",
                      text: formLang.invoiceOptions.noreceipt,
                      disabled: false,
                  },
              ]
            : [
                  {
                      id: "EMAIL",
                      text: formLang.invoiceOptions.email,
                      disabled: !!disableOthers,
                  },
                  {
                      id: "PAPER",
                      text:
                          formLang.invoiceOptions.paper +
                          ((props.editSettings &&
                              waitingListFlowContext.episerver.account_type ===
                                  "B2B") ||
                          waitingListFlowContext.episerver.PaymentInfoUrl
                              ? ""
                              : "¹"),
                      disabled: !!disableOthers,
                  },
                  ...(props.editSettings &&
                  (waitingListFlowContext.episerver.account_type === "B2C" ||
                      waitingListFlowContext.country === "se")
                      ? [
                            {
                                id: "E_INVOICE",
                                text:
                                    formLang.invoiceOptions.e_invoice +
                                    (props.editSettings &&
                                    waitingListFlowContext.episerver
                                        .account_type === "B2B"
                                        ? "¹"
                                        : ""),
                                disabled:
                                    formLang.invoicePreference !== "E_INVOICE",
                            },
                        ]
                      : []),
              ];

    const notificationOptions = [
        { id: "EMAIL", text: formLang.notificationOptions.email },
        { id: "PAPER", text: formLang.notificationOptions.paper },
    ];

    let shippingSameAsBillingDefault = false;
    if (
        waitingListFlowContext.country === "se" ||
        waitingListFlowContext.country === "no"
    ) {
        shippingSameAsBillingDefault = true;
    }
    const [shippingSameAsBilling, setShippingSameAsBilling] = useState({
        selected: shippingSameAsBillingDefault,
        elementType: "checkbox",
    });

    const defaultCountrySelection = (isShippingCountry = false) => {
        if (
            isShippingCountry &&
            !!waitingListFlowContext.episerver.shipping_country
        ) {
            return {
                item: countrySelectionOptions.find(
                    (country) =>
                        country.Id ===
                        waitingListFlowContext.episerver.shipping_country
                ),
                required: !shippingSameAsBilling.selected,
                elementType: "select",
            };
        } else if (
            !isShippingCountry &&
            !!waitingListFlowContext.episerver.billing_country
        ) {
            return {
                item: countrySelectionOptions.find(
                    (country) =>
                        country.Id ===
                        waitingListFlowContext.episerver.billing_country
                ),
                required: true,
                elementType: "select",
            };
        } else if (!waitingListFlowContext.episerver.billing_country) {
            return {
                item: { Text: formLang.countrySelect, Id: "" },
                required: !(
                    isShippingCountry && shippingSameAsBilling.selected
                ),
                elementType: "select",
            };
        }
        return {
            item: countrySelectionOptions.find(
                (country) =>
                    country.Id ===
                    waitingListFlowContext.episerver.billing_country
            ),
            required: true,
            elementType: "select",
        };
    };

    const defaultAccountState = () => {
        if (!!waitingListFlowContext.episerver.account_type) {
            return {
                item: accountSelectionOptions.find(
                    (accountType) =>
                        accountType.Value ===
                        waitingListFlowContext.episerver.account_type
                ),
                elementType: "select",
            };
        } else if (isGuestAccount) {
            return {
                item: { Text: "Guest", Id: 0, Value: "B2C" },
                elementType: "select",
            };
        }
        return { item: accountSelectionOptions[0], elementType: "select" };
    };

    const countryCallingCode = waitingListFlowContext.episerver.customer_phone;
    const [notification, setNotification] = useState({
        item: {
            id: props.editSettings
                ? waitingListFlowContext.episerver.notificationPreference
                : "EMAIL",
        },
        elementType: "radio",
    });
    const [invoice, setInvoice] = useState({
        item: {
            id: props.editSettings
                ? waitingListFlowContext.episerver.invoicePreference
                : "EMAIL",
        },
        elementType: "radio",
    });
    const [language, setLanguage] = useState({
        item: {
            id: props.editSettings
                ? waitingListFlowContext.episerver.languagePreference
                : waitingListFlowContext.localization.language,
        },
        elementType: "radio",
    });

    const [accountSelection, setAccountSelection] = useState(
        defaultAccountState()
    );
    const [companyName, setCompanyName] = useState({
        text: waitingListFlowContext.episerver.company_name,
        required: true,
    });
    const [organisationNumber, setOrganisationNumber] = useState({
        text: waitingListFlowContext.episerver.organisation_number,
        required: true,
        elementType: "organisation",
    });
    const [firstName, setFirstName] = useState({
        text: waitingListFlowContext.episerver.given_name ?? "",
        required: true,
    });
    const [lastName, setLastName] = useState({
        text: waitingListFlowContext.episerver.family_name ?? "",
        required: true,
    });
    const [ssn, setSsn] = useState({
        text: waitingListFlowContext.episerver.social_security_number,
        required: waitingListFlowContext.country === "se",
        elementType: "ssn",
        notSet: !!!waitingListFlowContext.episerver.social_security_number,
    });
    const [phone, setPhone] = useState({
        text: waitingListFlowContext.episerver.customer_phone,
        required: false,
        elementType: "phone",
    });
    const [mobile, setMobile] = useState({
        text: waitingListFlowContext.episerver.customer_mobile,
        required: false,
        elementType: "phone",
    });
    const [primaryContactEmailAddress, setPrimaryContactEmailAddress] =
        useState({
            text: waitingListFlowContext.episerver.emailAddress ?? "",
            required: true,
            elementType: "email",
        });
    const [invoiceEmail, setInvoiceEmail] = useState({
        text: waitingListFlowContext.episerver.invoice_email_address ?? "",
        required: invoice.item.id === "EMAIL" ? true : false,
        elementType: "email",
    });
    const [vatRegistrationNumber, setVatRegistrationNumber] = useState({
        text: waitingListFlowContext.episerver.vat_registration_number ?? "",
        required: false,
    });

    const [street, setStreet] = useState({
        text: waitingListFlowContext.episerver.billing_street,
        required: true,
    });
    const [street3, setStreet3] = useState({
        text: waitingListFlowContext.episerver.billing_street3,
        required: false,
    });
    const [box, setBox] = useState({
        text: waitingListFlowContext.episerver.billing_box,
        required: false,
    });
    const [co, setCO] = useState({
        text: waitingListFlowContext.episerver.billing_co,
        required: false,
    });
    const [attention, setAttention] = useState({
        text: waitingListFlowContext.episerver.billing_attention,
        required: false,
    });
    const [reference, setReference] = useState({
        text: waitingListFlowContext.episerver.billing_reference,
        required: false,
    });
    const [zipcode, setZipcode] = useState({
        text: waitingListFlowContext.episerver.billing_zip,
        required: true,
        elementType: "zipcode",
    });
    const [city, setCity] = useState({
        text: waitingListFlowContext.episerver.billing_city,
        required: true,
    });
    const [countrySelection, setCountrySelection] = useState(
        defaultCountrySelection(false)
    );

    const [shippingStreet, setShippingStreet] = useState({
        text: "",
        required: true,
    });
    const [shippingBox, setShippingBox] = useState({
        text: "",
        required: false,
    });
    const [shippingCO, setShippingCO] = useState({ text: "", required: false });
    const [shippingAttention, setShippingAttention] = useState({
        text: "",
        required: false,
    });
    const [shippingReference, setShippingReference] = useState({
        text: "",
        required: false,
    });
    const [shippingZipcode, setShippingZipcode] = useState({
        text: "",
        required: true,
        elementType: "zipcode",
    });
    const [shippingCity, setShippingCity] = useState({
        text: "",
        required: true,
    });
    const [shippingCountrySelection, setShippingCountrySelection] = useState(
        defaultCountrySelection(true)
    );

    const [privacyStatement, setPrivacyStatement] = useState({
        selected: !!props.editSettings,
        required: true,
        elementType: "checkbox",
    });
    const [marketingCompliance, setMarketingCompliance] = useState({
        selected: false,
        required: false,
        elementType: "checkbox",
    });
    const paymentMethod = waitingListFlowContext.episerver.paymentMethod;

    const formData = {
        notification,
        setNotification,
        notificationOptions,
        invoice,
        setInvoice,
        invoiceOptions,
        language,
        setLanguage,
        languageOptions,
        firstName,
        setFirstName,
        lastName,
        setLastName,
        ssn,
        setSsn,
        phone,
        setPhone,
        street,
        setStreet,
        street3,
        setStreet3,
        zipcode,
        setZipcode,
        city,
        setCity,
        box,
        setBox,
        co,
        setCO,
        attention,
        setAttention,
        reference,
        setReference,
        shippingStreet,
        setShippingStreet,
        shippingBox,
        setShippingBox,
        shippingCO,
        setShippingCO,
        shippingAttention,
        setShippingAttention,
        shippingReference,
        setShippingReference,
        shippingZipcode,
        setShippingZipcode,
        shippingCity,
        setShippingCity,
        shippingCountrySelection,
        setShippingCountrySelection,
        mobile,
        setMobile,
        companyName,
        setCompanyName,
        paymentMethod,
        organisationNumber,
        setOrganisationNumber,
        primaryContactEmailAddress,
        setPrimaryContactEmailAddress,
        vatRegistrationNumber,
        setVatRegistrationNumber,
        shippingSameAsBilling,
        setShippingSameAsBilling,
        invoiceEmail,
        setInvoiceEmail,
        countrySelection,
        setCountrySelection,
        countrySelectionOptions,
    };

    useEffect(() => {
        if (render.current > 2) setEnableSave(true);
        if (!shippingSameAsBilling.selected) {
            setShippingStreet({
                text:
                    waitingListFlowContext.episerver.shipping_street ||
                    street.text,
                required: true,
            });
            setShippingBox({
                text: waitingListFlowContext.episerver.shipping_box || box.text,
                required: false,
            });
            setShippingCO({
                text: waitingListFlowContext.episerver.shipping_co || co.text,
                required: false,
            });
            setShippingAttention({
                text:
                    waitingListFlowContext.episerver.shipping_attention ||
                    attention.text,
                required: false,
            });
            setShippingReference({
                text:
                    waitingListFlowContext.episerver.shipping_reference ||
                    reference.text,
                required: false,
            });
            setShippingZipcode({
                text:
                    waitingListFlowContext.episerver.shipping_zip ||
                    zipcode.text,
                required: true,
                elementType: "zipcode",
            });
            setShippingCity({
                text:
                    waitingListFlowContext.episerver.shipping_city || city.text,
                required: true,
            });
            setShippingCountrySelection(
                countrySelection.item.Id
                    ? {
                          item: { ...countrySelection.item },
                          required: true,
                          elementType: "select",
                      }
                    : defaultCountrySelection(true)
            );
        } else {
            setShippingCountrySelection(
                countrySelection.item.Id
                    ? {
                          item: { ...countrySelection.item },
                          required: false,
                          elementType: "select",
                      }
                    : defaultCountrySelection(true)
            );
        }
    }, [shippingSameAsBilling.selected]);

    useEffect(() => {
        if (render.current > 2) setEnableSave(true);
        if (invoice.item.id != "EMAIL") {
            const error = invoiceEmail.error ? null : invoiceEmail.error;
            if (
                accountSelection.item.Id === 1 ||
                accountSelection.item.Id === 2
            ) {
                setInvoiceEmail({ ...invoiceEmail, required: false, error });
            } else {
                setInvoiceEmail({ ...invoiceEmail, required: true, error });
            }
        } else setInvoiceEmail({ ...invoiceEmail, required: true });
    }, [invoice.item.id, accountSelection.item.Id]);

    useEffect(() => {
        if (render.current > 2) setEnableSave(true);
        if (notification.item.id === "EMAIL") {
            setPrimaryContactEmailAddress({
                ...primaryContactEmailAddress,
                required: true,
            });
        } else {
            const error =
                primaryContactEmailAddress.error &&
                accountSelection.item.Id == 2
                    ? null
                    : primaryContactEmailAddress.error;
            setPrimaryContactEmailAddress({
                ...primaryContactEmailAddress,
                required: accountSelection.item.Id == 2 ? false : true,
                error,
            });
        }
    }, [notification.item.id, accountSelection.item.Id]);

    useEffect(() => {
        if (render.current > 2) setEnableSave(true);
    }, [language.item.id]);

    useLayoutEffect(() => {
        if (render.current > 2) return;
        render.current++;
    });

    const handleKeyDown = function (event) {
        setEnableSave(true);
        if (event.key === "Enter") {
            createAccountHandler();
        }
    };

    useEffect(() => {
        if (render.current > 2) setEnableSave(true);
        setCountrySelection({ ...countrySelection, error: null });
    }, [countrySelection.item.Id]);

    const createAccountHandler = async () => {
        setError(null);
        let newAccountForm = {
            notificationPreference: {
                value: notification,
                setValue: setNotification,
            },
            invoiceMethod: { value: invoice, setValue: setInvoice },
            preferredLanguage: { value: language, setValue: setLanguage },
            billingStreet: { value: street, setValue: setStreet },
            billingStreet2: { value: box, setValue: setBox },
            billingStreet3: { value: street3, setValue: setStreet3 },
            billingCO: { value: co, setValue: setCO },
            billingAttention: { value: attention, setValue: setAttention },
            billingReference: { value: reference, setValue: setReference },
            billingPostalCode: { value: zipcode, setValue: setZipcode },
            billingCity: { value: city, setValue: setCity },
            billingCountry: {
                value: countrySelection,
                setValue: setCountrySelection,
            },
            invoiceEmailAddress: {
                value: invoiceEmail,
                setValue: setInvoiceEmail,
            },
            privacyStatement: {
                value: privacyStatement,
                setValue: setPrivacyStatement,
            },
            marketingCompliance: {
                value: marketingCompliance,
                setValue: setMarketingCompliance,
            },
            shippingSameAsBilling: {
                value: shippingSameAsBilling,
                setValue: setShippingSameAsBilling,
            },
        };

        if (
            (!isGuestAccount && accountSelection.item.Id === 0) ||
            accountSelection.item.Id === 1
        ) {
            newAccountForm = {
                ...newAccountForm,
                firstName: { value: firstName, setValue: setFirstName },
                lastName: { value: lastName, setValue: setLastName },
                socialSecurityNumber: { value: ssn, setValue: setSsn },
                primaryContactEmailAddress: {
                    value: primaryContactEmailAddress,
                    setValue: setPrimaryContactEmailAddress,
                },
                personMobilePhone: {
                    value:
                        countryCallingCode === mobile.text
                            ? {
                                  text: "",
                                  required: false,
                                  elementType: "phone",
                              }
                            : mobile,
                    setValue: setMobile,
                },
                phone: {
                    value:
                        countryCallingCode === phone.text
                            ? {
                                  text: "",
                                  required: false,
                                  elementType: "phone",
                              }
                            : phone,
                    setValue: setPhone,
                },
                shippingStreet: {
                    value: shippingStreet,
                    setValue: setShippingStreet,
                },
                shippingStreet2: {
                    value: shippingBox,
                    setValue: setShippingBox,
                },
                shippingCO: { value: shippingCO, setValue: setShippingCO },
                shippingAttention: {
                    value: shippingAttention,
                    setValue: setShippingAttention,
                },
                shippingReference: {
                    value: shippingReference,
                    setValue: setShippingReference,
                },
                shippingPostalCode: {
                    value: shippingZipcode,
                    setValue: setShippingZipcode,
                },
                shippingCity: {
                    value: shippingCity,
                    setValue: setShippingCity,
                },
                shippingCountry: {
                    value: shippingCountrySelection,
                    setValue: setShippingCountrySelection,
                },
            };
        } else if (!isGuestAccount && accountSelection.item.Id === 2)
            newAccountForm = {
                ...newAccountForm,
                name: { value: companyName, setValue: setCompanyName },
                primaryContactEmailAddress: {
                    value: primaryContactEmailAddress,
                    setValue: setPrimaryContactEmailAddress,
                },
                phone: {
                    value:
                        countryCallingCode === phone.text
                            ? {
                                  text: "",
                                  required: false,
                                  elementType: "phone",
                              }
                            : phone,
                    setValue: setPhone,
                },
                vatNumber: {
                    value: vatRegistrationNumber,
                    setValue: setVatRegistrationNumber,
                },
                organisationNumber: {
                    value: organisationNumber,
                    setValue: setOrganisationNumber,
                },
                shippingStreet: {
                    value: shippingStreet,
                    setValue: setShippingStreet,
                },
                shippingStreet2: {
                    value: shippingBox,
                    setValue: setShippingBox,
                },
                shippingCO: { value: shippingCO, setValue: setShippingCO },
                shippingAttention: {
                    value: shippingAttention,
                    setValue: setShippingAttention,
                },
                shippingReference: {
                    value: shippingReference,
                    setValue: setShippingReference,
                },
                shippingPostalCode: {
                    value: shippingZipcode,
                    setValue: setShippingZipcode,
                },
                shippingCity: {
                    value: shippingCity,
                    setValue: setShippingCity,
                },
                shippingCountry: {
                    value: shippingCountrySelection,
                    setValue: setShippingCountrySelection,
                },
            };
        else if (isGuestAccount)
            newAccountForm = {
                firstName: { value: firstName, setValue: setFirstName },
                lastName: { value: lastName, setValue: setLastName },
                personEmail: { value: email, setValue: setEmail },
                privacyStatement: {
                    value: privacyStatement,
                    setValue: setPrivacyStatement,
                },
                marketingCompliance: {
                    value: marketingCompliance,
                    setValue: setMarketingCompliance,
                },
            };
        let [formValidationError, cleanFormData, flatCleanFormData] =
            validateFormObject(
                newAccountForm,
                formLang.errorMessages,
                waitingListFlowContext.country
            );

        if (formValidationError) {
            if (
                flatCleanFormData.personMobilePhone?.value === "" ||
                !flatCleanFormData.personMobilePhone
            )
                setMobile({
                    text: waitingListFlowContext.episerver.customer_mobile,
                    required: false,
                    elementType: "phone",
                });
            if (
                flatCleanFormData.phone?.value === "" ||
                !flatCleanFormData.phone
            )
                setPhone({
                    text: waitingListFlowContext.episerver.customer_phone,
                    required: false,
                    elementType: "phone",
                });
            setTimeout(() => setError({ error: true }), 250);
            return;
        }
        setPending(true);
        const createdCustomer = await account.createOrEditCustomer(
            {
                bookingController:
                    waitingListFlowContext.episerver.bookingController,
                form: {
                    ...flatCleanFormData,
                    recordType: accountSelection.item.Value,
                    uid: props.editSettings
                        ? waitingListFlowContext.episerver.uid
                        : null,
                    updateSSN: ssn.notSet,
                },
            },
            waitingListFlowContext.useMockedData,
            currentLanguage
        );

        if (!createdCustomer.status || createdCustomer.status !== 200) {
            setPending(false);
            if (shouldAccountBeUpdated(waitingListFlowContext)) {
                setError({ error: true, errorText: formLang.anerroroccurred });
            } else {
                setError({
                    error: true,
                    errorText: createdCustomer.errorMessage,
                });
            }
            return;
        }

        if (process.env.NODE_ENV !== "production") {
            if (waitingListFlowContext.useMockedLogin) {
                console.log("createdCustomer", createdCustomer);
            }
        }

        setEnableSave(false);
        setPending(false);
        setTimeout(() => setShowSaveButtonCheck(true), 10);

        if (!props.editSettings && !props.formLogin) {
            setTimeout(() => {
                setWaitingListFlowContext({
                    ...waitingListFlowContext,
                    activeStep: waitingListFlowContext.vehicle.index,
                    user: {
                        email: waitingListFlowContext.episerver.emailAddress,
                        givenName: waitingListFlowContext.episerver.given_name,
                        familyName:
                            waitingListFlowContext.episerver.family_name,
                    },
                    createAccount: {
                        ...waitingListFlowContext.createAccount,
                        formData: cleanFormData,
                    },
                });
            }, 1000);
        } else {
            if (props.editSettings) {
                setTimeout(() => setShowSaveButtonCheck(false), 2000);
            }
            if (props.formLogin) {
                setTimeout(
                    () => (window.location.href = window.location.href),
                    500
                );
            }
        }
    };

    useEffect(() => {
        if (!error || error.errorText?.length > 0) return;

        const firstInvalidElement = document.querySelector("[aria-invalid]");

        if (firstInvalidElement)
            firstInvalidElement.scrollIntoView({ behavior: "smooth" });
        else if (topOfContainerRef && topOfContainerRef.current)
            topOfContainerRef.current.scrollIntoView({ behavior: "smooth" });
    }, [error]);

    return (
        <div className="waitinglistflowpagewaitinglistflowpage__app waitinglistflowpage__app--createaccount">
            {!props.editSettings && !props.formLogin && (
                <Fragment>
                    <Heading />
                </Fragment>
            )}
            <div
                className="single-step single-step--createaccount"
                ref={topOfContainerRef}
            >
                {!props.editSettings && (
                    <h2>
                        {shouldAccountBeUpdated(waitingListFlowContext)
                            ? formLang.updateAccountHeading
                            : formLang.heading}
                    </h2>
                )}

                {!isGuestAccount &&
                    !shouldAccountBeUpdated(waitingListFlowContext) &&
                    !props.editSettings && (
                        <Fragment>
                            <TwoColumnWrapper>
                                <DropdownlistWithLabel
                                    text={formLang.accountType}
                                    options={accountSelectionOptions}
                                    value={accountSelection}
                                    setValue={setAccountSelection}
                                />
                            </TwoColumnWrapper>
                            <Divider />
                        </Fragment>
                    )}
                {!isGuestAccount &&
                    (accountSelection.item.Id === 0 ||
                        accountSelection.item.Id === 1 ||
                        (props.editSettings &&
                            waitingListFlowContext.episerver.account_type !==
                                "B2B")) && (
                        <CreateAccountPrivate
                            waitingListFlowContext={waitingListFlowContext}
                            formData={formData}
                            keyDown={handleKeyDown}
                        />
                    )}
                {!isGuestAccount &&
                    (accountSelection.item.Id === 2 ||
                        waitingListFlowContext.episerver.account_type ===
                            "B2B") && (
                        <CreateAccountBusiness
                            waitingListFlowContext={waitingListFlowContext}
                            formData={formData}
                            keyDown={handleKeyDown}
                        />
                    )}
                {isGuestAccount && (
                    <CreateAccountGuest
                        waitingListFlowContext={waitingListFlowContext}
                        formData={formData}
                        keyDown={handleKeyDown}
                    />
                )}

                <Divider />

                {/* Ska dessa finnas med när man uppdaterar? Vill man spara valen i BE? */}
                {!props.editSettings && (
                    <Fragment>
                        <h3>Terms and conditions</h3>
                        <CheckboxWithLabel
                            text={formLang.privacyStatement}
                            value={privacyStatement}
                            setValue={setPrivacyStatement}
                        />
                        <CheckboxWithLabel
                            text={formLang.marketingCompliance}
                            value={marketingCompliance}
                            setValue={setMarketingCompliance}
                        />
                    </Fragment>
                )}
                {error && error.errorText?.length > 0 && (
                    <Error text={error.errorText} />
                )}
                <div className="CTA-buttons">
                    <BackNavigation type={"CTA"} />
                    <button
                        className={`cta-button single-step__button single-step__button--saveable single-step__button--createaccount ${
                            showSaveButtonCheck
                                ? "single-step__button--complete"
                                : ""
                        }`}
                        data-map-button={
                            props.editSettings ? "save-settings" : undefined
                        }
                        disabled={
                            pending ||
                            !privacyStatement.selected ||
                            (props.editSettings && !enableSave) ||
                            showSaveButtonCheck
                        }
                        aria-busy={pending}
                        onClick={createAccountHandler}
                    >
                        {shouldAccountBeUpdated(waitingListFlowContext)
                            ? formLang.submitupdateform
                            : props.editSettings
                            ? formLang.savechanges
                            : formLang.submitform}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateAccount;
